import { getInstance, whenBrazeIsReady } from '../../braze'

export { type BrazeInstance } from '../../braze'

/**
 * Returns the current Braze SDK instance, or null if not yet initialized or disabled.
 * Prefer whenBrazeIsReady() when you need to wait for Braze to be ready before using it.
 */
export function getBrazeInstance() {
  return getInstance()
}

export { whenBrazeIsReady }
